import { useAuthor } from '@/hooks/useAuthor';
import { ownerPubkey } from '@/lib/owner';
import { siteConfig } from '@/config/site';

/**
 * Everything the UI needs to know about the site owner.
 * When `siteConfig.useNostrProfile` is on, name/avatar/banner come from the
 * owner's kind-0 Nostr profile; otherwise the static config values are used.
 */
export function useSiteOwner() {
  const author = useAuthor(ownerPubkey || undefined);
  const metadata = author.data?.metadata;

  const name = siteConfig.useNostrProfile
    ? metadata?.display_name || metadata?.name || siteConfig.name
    : siteConfig.name;

  return {
    pubkey: ownerPubkey,
    npub: siteConfig.ownerNpub,
    name,
    picture: siteConfig.useNostrProfile ? metadata?.picture : undefined,
    banner: siteConfig.useNostrProfile ? metadata?.banner : undefined,
    nip05: metadata?.nip05,
    about: metadata?.about,
    lightning: metadata?.lud16 || metadata?.lud06 || siteConfig.lightningAddress || undefined,
    isLoading: author.isLoading,
  };
}
